import React from 'react'
import "./HeroPage.css"
import Home from '../pages/Home'
import Header from './Header'
import Clients from '../pages/Clients'
import Services from '../pages/Services'
import OurProjects from '../pages/OurProjects'
import MeetTeam from '../pages/MeetTeam'
import Footer from './Footer'

const HeroPage = () => {
  return (
    <div className='main'>
    <Header/>
    <Home/>
    <Clients/>
    <Services/>
    <OurProjects/>
    <MeetTeam/>
    <Footer/>
    </div>
  )
}

export default HeroPage